module.exports = "http://cdn.realive.com.ua/src/views/games/other/images/maps/mafia2.png";